import React, { useEffect, useState, useRef } from "react";

import Countdown from "react-countdown";
import "./TinyRowTrip.scss";
import { TinyTrip } from "./TinyTrip";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { Stack } from "@mui/system";
import { useWindowSize } from "../customHooks/useWindowSize";
import { useIsMobile } from "../hooks/responsive";
import { useScrollPreservation } from "../hooks/useScrollPreservation";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useGlobalState } from "../GlobalStates";
import { useNavigate } from "react-router-dom";

export const DisplayRow = ({
  rowTitle,
  rowDesc = null,
  trips = [],
  projectView = false,
  CountdownEndDate = null,
  rowStyle = {},
  rowTitleStyle = {},
  onTripClick = null,
  onRowTitleClick = null,
  disableSearch,
  sectionKey = null,
  broad = null,
  dateView = false,
  showAllTrips = false,
}) => {
  const isMobile = useIsMobile();
  const size = useWindowSize();
  const navigate = useNavigate();

  const [quickSearch, setQuickSearch] = useGlobalState("quickSearch");
  const [resetDisplaySearch, setResetDisplaySearch] = useGlobalState("resetDisplaySearch");

  const [lastClick, setLastClick] = useState("left"); // right
  const [showSlideLeft, setShowSlideLeft] = useState(false);
  const [showSlideRight, setShowSlideRight] = useState(false);

  useEffect(() => {
    if (size.width > 1600) {
      setShowSlideRight(trips.length > 5);
    } else {
      setShowSlideRight(trips.length > 4);
    }
  }, [size.width]);

  const rowRef = useRef(null);
  const slideLeft = () => {
    setLastClick("left");
    setShowSlideLeft(false);
    rowRef.current.scrollBy({ left: -1000, behavior: "smooth" }); // Adjust the scroll distance as needed
  };
  const slideRight = () => {
    setLastClick("right");
    setShowSlideRight(false);
    rowRef.current.scrollBy({ left: 1000, behavior: "smooth" }); // Adjust the scroll distance as needed
  };

  // Use scroll preservation hook
  useScrollPreservation(rowRef, rowTitle, "x");

  useEffect(() => {
    // init horizontal scroll ref
    const handleScroll = () => {
      const currentScrollLeft = rowRef.current.scrollLeft;

      // Update show left arrow state
      if (currentScrollLeft !== 0) {
        setShowSlideLeft(true);
        setShowSlideRight(false);
      } else {
        setShowSlideLeft(false);
        setShowSlideRight(true);
      }
    };

    const currentRowRef = rowRef.current;
    if (currentRowRef) {
      currentRowRef.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (currentRowRef) {
        currentRowRef.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const [searchedTrips, setSearchedTrips] = useGlobalState("searchedTrips");

  const handleSearchTrips = () => {
    if (onRowTitleClick) {
      onRowTitleClick();
      return;
    }

    if (disableSearch) {
      return;
    }

    setQuickSearch(true);
    setResetDisplaySearch(true);

    const queryParams = new URLSearchParams();
    if (broad) {
      queryParams.set("broad", broad);
    }
    if (dateView) {
      queryParams.set("date_view", "1");
    }
    if (sectionKey) {
      queryParams.set("section", sectionKey);
    } else {
      // Fallback for rows without a section key
      queryParams.set("tab", rowTitle);
      queryParams.set("trip", trips.map((trip) => trip.id).join(","));
    }

    setSearchedTrips(trips);

    navigate({
      pathname: "/all-trips",
      search: queryParams.toString(),
    });
  };

  return (
    <>
      {trips && trips.length > 0 && (
        <>
          <div className="RowDescWrapper">
            {showSlideLeft && !isMobile && (
              <button className="RowScrollCircleButtonLeft" onClick={slideLeft}>
                <FontAwesomeIcon icon={faChevronLeft} className="RowScrollCircleButtonLeftArrow" />
              </button>
            )}

            {showSlideRight && !isMobile && (
              <button className="RowScrollCircleButtonRight" onClick={slideRight}>
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="RowScrollCircleButtonRightArrow"
                />
              </button>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <span style={rowTitleStyle} className="RowTitle" onClick={handleSearchTrips}>
                {rowTitle}
              </span>
              {!disableSearch && (
                <ChevronRightIcon
                  onClick={handleSearchTrips}
                  style={{
                    cursor: "pointer",
                    color: "black",
                    fontSize: isMobile ? "20px" : "25px",
                    fontWeight: "bold",
                    marginLeft: "3px",
                  }}
                />
              )}
              {CountdownEndDate && (
                <span style={{ marginTop: "5px", marginBottom: "5px" }}>
                  <Countdown
                    date={CountdownEndDate}
                    renderer={({ days, hours, minutes, seconds, completed }) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            width: "16rem",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "2rem",
                              width: "4.5rem",
                              backgroundColor: "black",
                              borderRadius: "8px",
                            }}
                          >
                            <span style={{ color: "white" }}>
                              {days <= 1 ? `${days} day` : `${days} days`}
                            </span>
                          </div>
                          :
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "2rem",
                              width: "3rem",
                              backgroundColor: "black",
                              borderRadius: "8px",
                            }}
                          >
                            <span style={{ color: "white" }}>{String(hours).padStart(2, "0")}</span>
                          </div>
                          :
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "2rem",
                              width: "3rem",
                              backgroundColor: "black",
                              borderRadius: "8px",
                            }}
                          >
                            <span style={{ color: "white" }}>
                              {String(minutes).padStart(2, "0")}
                            </span>
                          </div>
                          :
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "center",
                              height: "2rem",
                              width: "3rem",
                              backgroundColor: "black",
                              borderRadius: "8px",
                            }}
                          >
                            <span style={{ color: "white" }}>
                              {String(seconds).padStart(2, "0")}
                            </span>
                          </div>
                        </div>
                      );
                    }}
                  />
                </span>
              )}
            </div>
            {rowDesc && <p className="RowDesc">{rowDesc}</p>}
          </div>

          <div className="RowForTinyTrip" ref={rowRef} style={rowStyle}>
            {(showAllTrips ? trips : trips.slice(0, 8)).map(
              ({
                id,
                project_id,
                project_name,
                age_restriction,
                duration,
                start_date,
                start_time,
                end_date,
                city,
                country,
                meeting_point,
                num_slots_paid,
                total_slots,
                main_images,
                price,
                currency,
                skill_level,
                three_user_images,
                status,
                booking_open_date,
                coordinator_image,
                coordinator_type,
                trip_type,
                main_video,
                early_bird_percentage,
                late_bird_percentage,
                min_price,
                highlights,
                free_reserve_allowed,
                newLaunch,
                userReview,
                leader_requirement,
                leader_incentive_max,
                num_nights,
                soclub_weekly_type,
                broad_category,
                total_review_count,
                total_review_score,
                allow_public_trip_creation,
                is_dateless,
                view_participants_in_app,

                friend_id,
                friend_image,
                friend_name,
                friend_book_date,
              }) => (
                <TinyTrip
                  leader_requirement={leader_requirement}
                  projectView={projectView}
                  min_price={min_price}
                  key={`${id ?? "p"}-${project_id}`}
                  trip_id={id}
                  project_id={project_id}
                  name={project_name}
                  age_restriction={age_restriction}
                  duration={duration}
                  start_date={start_date}
                  start_time={start_time}
                  end_date={end_date}
                  city={city}
                  country={country}
                  meeting_point={meeting_point}
                  num_slots_paid={num_slots_paid}
                  total_slots={total_slots}
                  main_images={main_images}
                  price={price}
                  currency={currency}
                  skill_level={skill_level}
                  three_user_images={three_user_images}
                  status={status}
                  booking_open_date={booking_open_date}
                  coordinator_image={coordinator_image}
                  coordinator_type={coordinator_type}
                  trip_type={trip_type}
                  main_video={main_video}
                  early_bird_percentage={early_bird_percentage}
                  late_bird_percentage={late_bird_percentage}
                  highlights={highlights}
                  free_reserve_allowed={free_reserve_allowed}
                  newLaunch={newLaunch}
                  rowTitle={rowTitle}
                  userReview={userReview}
                  leader_incentive_max={leader_incentive_max}
                  num_nights={num_nights}
                  soclub_weekly_type={soclub_weekly_type}
                  broad_category={broad_category}
                  total_review_count={total_review_count}
                  total_review_score={total_review_score}
                  onTripClick={onTripClick}
                  allow_public_trip_creation={allow_public_trip_creation}
                  is_dateless={is_dateless}
                  view_participants_in_app={view_participants_in_app}
                  friend_id={friend_id}
                  friend_image={friend_image}
                  friend_name={friend_name}
                  friend_book_date={friend_book_date}
                />
              )
            )}

            {!disableSearch && !showAllTrips && trips.length > 2 && (
              <div
                style={{
                  height: "10.4rem",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <button className="RowScrollCircleButtonMore" onClick={handleSearchTrips}>
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    className="RowScrollCircleButtonMoreArrow"
                  />
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};
